"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Link = require("./Link");

var _Link2 = _interopRequireDefault(_Link);

var _CommentAreaTitle = require("./CommentAreaTitle");

var _CommentAreaTitle2 = _interopRequireDefault(_CommentAreaTitle);

var _NestedListing = require("./NestedListing");

var _NestedListing2 = _interopRequireDefault(_NestedListing);

var _SortSelector = require("./SortSelector");

var _SortSelector2 = _interopRequireDefault(_SortSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CommentArea = function CommentArea(_ref) {
  var _ref$Link = _ref.Link,
      Link = _ref$Link === undefined ? _Link2.default : _ref$Link,
      _ref$NestedListing = _ref.NestedListing,
      NestedListing = _ref$NestedListing === undefined ? _NestedListing2.default : _ref$NestedListing,
      _ref$CommentAreaTitle = _ref.CommentAreaTitle,
      CommentAreaTitle = _ref$CommentAreaTitle === undefined ? _CommentAreaTitle2.default : _ref$CommentAreaTitle,
      _ref$SortSelector = _ref.SortSelector,
      SortSelector = _ref$SortSelector === undefined ? _SortSelector2.default : _ref$SortSelector,
      _ref$hideSortOptions = _ref.hideSortOptions,
      hideSortOptions = _ref$hideSortOptions === undefined ? "true" : _ref$hideSortOptions,
      _ref$currentSort = _ref.currentSort,
      currentSort = _ref$currentSort === undefined ? "best" : _ref$currentSort,
      _ref$sortOptions = _ref.sortOptions,
      sortOptions = _ref$sortOptions === undefined ? ["best", "top", "new", "controversial", "old", "random", "q&a"] : _ref$sortOptions,
      name = _ref.name,
      replyTo = _ref.replyTo,
      num_comments = _ref.num_comments,
      commentsTitle = _ref.commentsTitle,
      permalink = _ref.permalink,
      locked = _ref.locked,
      allChildren = _ref.allChildren,
      props = _objectWithoutProperties(_ref, ["Link", "NestedListing", "CommentAreaTitle", "SortSelector", "hideSortOptions", "currentSort", "sortOptions", "name", "replyTo", "num_comments", "commentsTitle", "permalink", "locked", "allChildren"]);

  return _react2.default.createElement(
    "div",
    { className: "commentarea" },
    _react2.default.createElement(CommentAreaTitle, { num_comments: num_comments, commentsTitle: commentsTitle }),
    _react2.default.createElement(SortSelector, { currentSort: currentSort, sortOptions: sortOptions, hideSortOptions: hideSortOptions }),
    _react2.default.createElement(NestedListing, _extends({ className: "nestedlisting" }, _extends({}, props, { name: name, replyTo: replyTo, allChildren: allChildren, showReplyForm: !locked, locked: locked }))),
    _react2.default.createElement(
      "div",
      { className: "gold-wrap cloneable-comment" },
      _react2.default.createElement(
        "h1",
        { className: "gold-banner" },
        _react2.default.createElement(
          Link,
          { href: "/gold" },
          "reddit gold"
        )
      ),
      _react2.default.createElement(
        "div",
        { className: "fancy" },
        _react2.default.createElement(
          "div",
          { className: "fancy-inner" },
          _react2.default.createElement(
            "div",
            { className: "fancy-content" },
            _react2.default.createElement(
              "div",
              { className: "gold-form gold-payment" },
              _react2.default.createElement(
                "button",
                { className: "close-button" },
                "close"
              ),
              _react2.default.createElement(
                "div",
                { className: "container" },
                _react2.default.createElement(
                  "h2",
                  { className: "sidelines" },
                  _react2.default.createElement(
                    "span",
                    null,
                    "In Summation"
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: "transaction-summary" },
                  _react2.default.createElement(
                    "p",
                    null,
                    "Want to say thanks to ",
                    _react2.default.createElement(
                      "em",
                      null,
                      "%(recipient)s"
                    ),
                    " for this comment? Give them a month of",
                    " ",
                    _react2.default.createElement(
                      Link,
                      { href: "/gold/about" },
                      "reddit gold"
                    ),
                    "."
                  ),
                  _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                      "blockquote",
                      null,
                      _react2.default.createElement(
                        "p",
                        null,
                        "By purchasing Reddit Gold, you agree to the",
                        " ",
                        _react2.default.createElement(
                          Link,
                          { href: "/help/useragreement" },
                          "Reddit User Agreement."
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                "ul",
                { className: "indent" },
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement("input", {
                    defaultChecked: true,
                    id: "signed-false",
                    name: "signed",
                    type: "checkbox"
                  }),
                  "make my gift anonymous"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement("input", { id: "message", name: "message", type: "checkbox" }),
                  "include a message"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement("textarea", {
                    className: "hidden giftmessage",
                    cols: 50,
                    id: "giftmessage",
                    maxLength: 500,
                    name: "giftmessage",
                    placeholder: "enter your message",
                    rows: 3,
                    defaultValue: ""
                  })
                )
              ),
              _react2.default.createElement(
                "div",
                { className: "buttons" },
                _react2.default.createElement(
                  "p",
                  null,
                  "Please select a payment method."
                ),
                _react2.default.createElement(
                  "div",
                  { className: "note" },
                  _react2.default.createElement(
                    "p",
                    null,
                    "Give gold often? Consider",
                    " ",
                    _react2.default.createElement(
                      Link,
                      { href: "/creddits" },
                      "buying creddits to use"
                    ),
                    ", they're 40% cheaper if purchased in a set of 12."
                  ),
                  _react2.default.createElement(
                    "p",
                    null,
                    "Would you like to",
                    " ",
                    _react2.default.createElement(
                      Link,
                      { href: "/gilding" },
                      "learn more about giving gold"
                    ),
                    "?"
                  )
                )
              ),
              _react2.default.createElement("div", { className: "throbber" })
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      "div",
      { className: "gold-wrap cloneable-link" },
      _react2.default.createElement(
        "h1",
        { className: "gold-banner" },
        _react2.default.createElement(
          Link,
          { href: "/gold" },
          "reddit gold"
        )
      ),
      _react2.default.createElement(
        "div",
        { className: "fancy" },
        _react2.default.createElement(
          "div",
          { className: "fancy-inner" },
          _react2.default.createElement(
            "div",
            { className: "fancy-content" },
            _react2.default.createElement(
              "div",
              { className: "gold-form gold-payment" },
              _react2.default.createElement(
                "button",
                { className: "close-button" },
                "close"
              ),
              _react2.default.createElement(
                "div",
                { className: "container" },
                _react2.default.createElement(
                  "h2",
                  { className: "sidelines" },
                  _react2.default.createElement(
                    "span",
                    null,
                    "In Summation"
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: "transaction-summary" },
                  _react2.default.createElement(
                    "p",
                    null,
                    "Want to say thanks to ",
                    _react2.default.createElement(
                      "em",
                      null,
                      "%(recipient)s"
                    ),
                    " for this submission? Give them a month of",
                    " ",
                    _react2.default.createElement(
                      Link,
                      { href: "/gold/about" },
                      "reddit gold"
                    ),
                    "."
                  ),
                  _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                      "blockquote",
                      null,
                      _react2.default.createElement(
                        "p",
                        null,
                        "By purchasing Reddit Gold, you agree to the",
                        " ",
                        _react2.default.createElement(
                          Link,
                          { href: "/help/useragreement" },
                          "Reddit User Agreement."
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                "ul",
                { className: "indent" },
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement("input", {
                    defaultChecked: true,
                    id: "signed-false",
                    name: "signed",
                    type: "checkbox"
                  }),
                  "make my gift anonymous"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement("input", { id: "message", name: "message", type: "checkbox" }),
                  "include a message"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement("textarea", {
                    className: "hidden giftmessage",
                    cols: 50,
                    id: "giftmessage",
                    maxLength: 500,
                    name: "giftmessage",
                    placeholder: "enter your message",
                    rows: 3,
                    defaultValue: ""
                  })
                )
              ),
              _react2.default.createElement(
                "div",
                { className: "buttons" },
                _react2.default.createElement(
                  "p",
                  null,
                  "Please select a payment method."
                ),
                _react2.default.createElement(
                  "div",
                  { className: "note" },
                  _react2.default.createElement(
                    "p",
                    null,
                    "Give gold often? Consider",
                    " ",
                    _react2.default.createElement(
                      Link,
                      { href: "/creddits" },
                      "buying creddits to use"
                    ),
                    ", they're 40% cheaper if purchased in a set of 12."
                  ),
                  _react2.default.createElement(
                    "p",
                    null,
                    "Would you like to",
                    " ",
                    _react2.default.createElement(
                      Link,
                      { href: "/gilding" },
                      "learn more about giving gold"
                    ),
                    "?"
                  )
                )
              ),
              _react2.default.createElement("div", { className: "throbber" })
            )
          )
        )
      )
    )
  );
};

exports.default = CommentArea;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/CommentArea.js
// module id = 300
// module chunks = 0